'use strict';

var React = require('react'),
    Icon = require('../atoms/Icon'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

require('./Notification.less');

var Notification = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    content: PropTypes.node.isRequired,
    action: PropTypes.node,
    onCloseClick: PropTypes.func.isRequired
  },

  getDefaultProps() {
    return {
      showCloseButton: true
    };
  },

  render() {
    var content = this.props.content,
        action = this.props.action,
        handleCloseClick = this.props.onCloseClick;

    return (
      <div className={this.getClassName()}>
        <div className='Notification-container'>
          <div className='Notification-body'>
            <div className='Notification-message'>
              {content}
            </div>

            {action &&
              <div className='Notification-action'>
                {action}
              </div>
            }
          </div>

          <span className='Notification-close' onTouchTap={handleCloseClick}>
            <Icon name='cross'
                  size='xsmall'
                  mode='stroke' />
          </span>
        </div>
      </div>
    );
  }
});

module.exports = Notification;



/** WEBPACK FOOTER **
 ** ./organisms/Notification.jsx
 **/